import styled, { css } from 'styled-components';

import Button from '../../../_shared/components/Button';
import { ListVariant } from '../../../_shared/types/trade';

export const FilterWrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  width: 100%;
  min-width: 240px;
  position: relative;

  .rc-slider {
    margin: 0 5px;
    width: calc(100% - 14px);

    &-handle:active {
      box-shadow: 0 0 0 5px ${({ theme }) => theme.COLORS.TERTIARY};
    }
  }
`;

export const Content = styled.div`
  padding: 0 12px;
  @media only screen and (max-width: 1749px) {
    padding-bottom: ${({ variant, filtersSpanHeight, isEditing }) =>
      variant === ListVariant.GRID && filtersSpanHeight && isEditing
        ? 40
        : 0}px;
  }
  &::-webkit-scrollbar {
    width: 0px;
  }
`;

const smallScreenGridViewFooterStyles = css`
  @media only screen and (max-width: 1749px) {
    position: ${({ filtersSpanHeight }) =>
      filtersSpanHeight ? 'fixed' : 'static'};
    ${({ filtersSpanHeight }) => filtersSpanHeight && 'width: 240px;'}
  }
`;

export const Footer = styled.div`
  display: flex;
  position: sticky;
  ${({ variant }) =>
    variant === ListVariant.GRID && smallScreenGridViewFooterStyles}
  left: 0;
  bottom: 0;
  border-top: 2px solid ${({ theme }) => theme.COLORS.LIGHT_SILVER};
  background-color: ${({ theme }) => theme.COLORS.BASE};
  height: 60px;
`;

export const SaveButton = styled(Button)`
  border: 2px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
  background-color: ${({ theme }) => theme.COLORS.BASE};
  padding: 9px 26px;
  margin: 12px;
  margin-left: auto;
  border-radius: 4px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  height: 36px;
`;

export const SliderLabel = styled.label`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  margin-right: 6px;
  color: ${props =>
    props.isEditing
      ? props.theme.COLORS.BASE_INVERTED
      : props.theme.COLORS.NEUTRAL_30};
`;

export const SliderValues = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  font-family: ${({ isEditing, theme }) => isEditing && theme.FONT.SEMI_BOLD};
  display: inline-block;
  align-self: center;
  white-space: nowrap;
`;

export const OverlayWrapper = styled.div`
  position: relative;
  opacity: ${props => !props.canEdit && '0.5'};
`;

export const Overlay = styled.div`
  z-index: 5000;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
`;
